"use strict";
/// <reference path="irep.js"/>

IREP.RefreshCache = (function () {

    var init = function () {
    };

    var RefreshCache = function (cultureCode) {

        $("#btn" + cultureCode).hide();

        $.ajax({ url: window.location.origin + "/50/localization/refreshcachebyculture?cultureCode=" + cultureCode })
        .done(function (data) {
            $("#div" + cultureCode).addClass(data == "Success" ? "done" : "error");
        }).fail(function () {
            $("#div" + cultureCode).addClass("error");
        });
       
    }

    var RefreshAllCultures = function (cultureCodes) {
        var self = this;
        var codes = cultureCodes.split(',');

        $(".refreshAll").hide();

        $.each(codes, function (key, value){
            self.RefreshCache(value);
        });
    }

    return {
        init: init,
        RefreshCache: RefreshCache,
        RefreshAllCultures: RefreshAllCultures
    };
})();